import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
export type BaseButtonProps = {
    isRounded?: boolean,
    isDark?: boolean,
    isWhite?: boolean,
    isTransparent?: boolean,
    isLink?: boolean,
    linkTo?: string,
    noPadding?: boolean,
    loading?: boolean,
    justifyContent?: 'start' | 'center' | 'end',
    type?: 'submit' | 'button'
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
    isRounded: { type: Boolean },
    isDark: { type: Boolean },
    isWhite: { type: Boolean },
    isTransparent: { type: Boolean },
    isLink: { type: Boolean },
    linkTo: { default: '' },
    noPadding: { type: Boolean },
    loading: { type: Boolean },
    justifyContent: { default: 'start' },
    type: { default: 'button' }
  },
  setup(__props: any) {

const props = __props as { isRounded?: boolean, isDark?: boolean, isWhite?: boolean, isTransparent?: boolean, isLink?: boolean, linkTo: string, noPadding?: boolean, loading?: boolean, justifyContent: 'start' | 'center' | 'end', type: 'submit' | 'button' };




const classes = computed(() => {
  const result:Array<string> = []

  const checks = {
    '--rounded': props.isRounded,
    '--dark': props.isDark,
    '--white': props.isWhite,
    '--transparent': props.isTransparent,
    '--no-pad': props.noPadding,
    '--loading': props.loading
  }

  for (const key in checks) {
    if (checks[key]) { result.push(key) }
  }

  result.push(props.justifyContent === 'center' ? '--justify__center' : `--justify__flex-${props.justifyContent}`)

  return result
})


return { __sfc: true,props, classes }
}

})